export function EmptyState({ icon: Icon, message }) {
  return (
    <div className="bg-white border border-[#E2E8F0] p-12 text-center" data-testid="empty-state">
      <Icon size={48} className="mx-auto text-[#64748B] mb-4" />
      <p className="text-[#64748B]">{message}</p>
    </div>
  );
}
